import React, { useState } from 'react';
import { FiDownload, FiShare, FiPlusSquare, FiX } from 'react-icons/fi';
import usePwaInstall from '../../hooks/usePwaInstall';
import {
    LoginWrap,
    LoginDivider,
    LoginButton,
    LoginHint,
    MenuButton,
    Overlay,
    Modal,
    CloseBtn,
    Steps,
} from './styles';

/**
 * Botão "Instalar aplicativo".
 * variant="login" → bloco grande no rodapé das telas de login
 * variant="menu"  → item do menu hambúrguer (mobile)
 * Some sozinho quando o app já está instalado ou o navegador não permite instalar.
 */
export function InstallAppButton({ variant = 'login' }) {
    const { showInstall, canPrompt, ios, install } = usePwaInstall();
    const [openIOS, setOpenIOS] = useState(false);

    if (!showInstall) return null;

    const handleClick = async () => {
        if (canPrompt) {
            await install();
        } else if (ios) {
            setOpenIOS(true);
        }
    };

    const iosModal = openIOS && (
        <Overlay onClick={() => setOpenIOS(false)}>
            <Modal onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
                <CloseBtn type="button" onClick={() => setOpenIOS(false)} aria-label="Fechar">
                    <FiX size={20} />
                </CloseBtn>
                <h3>Instalar no iPhone / iPad</h3>
                <Steps>
                    <li>Abra este site no <strong>Safari</strong>.</li>
                    <li>Toque em <strong>Compartilhar</strong> <FiShare size={16} />.</li>
                    <li>Escolha <strong>Adicionar à Tela de Início</strong> <FiPlusSquare size={16} />.</li>
                    <li>Toque em <strong>Adicionar</strong>.</li>
                </Steps>
            </Modal>
        </Overlay>
    );

    if (variant === 'menu') {
        return (
            <>
                <MenuButton type="button" onClick={handleClick}>
                    <FiDownload size={20} /> Instalar aplicativo
                </MenuButton>
                {iosModal}
            </>
        );
    }

    return (
        <LoginWrap>
            <LoginDivider><span>ou</span></LoginDivider>
            <LoginButton type="button" onClick={handleClick}>
                <FiDownload size={22} />
                <span>Baixar o aplicativo</span>
            </LoginButton>
            <LoginHint>Acesse o Diário Escolar direto da tela inicial do seu celular.</LoginHint>
            {iosModal}
        </LoginWrap>
    );
}

export default InstallAppButton;
